import { client } from '../client';
import { UserProfile } from './types/UserProfile';

/** POST /collector/users/:id/reactivate — restore a deactivated user in collector scope. */
export const reactivateCollectorUserById = async (userId: number): Promise<UserProfile> => {
  const { data } = await client.post<UserProfile>(`/collector/users/${userId}/reactivate`);
  return data;
};
